package nacholab.supplies.components

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.AnimationIterationCount
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.animation
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.rotateZ
import com.varabyte.kobweb.silk.components.icons.fa.FaSpinner
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.style.animation.Keyframes
import com.varabyte.kobweb.silk.style.animation.toAnimation
import nacholab.supplies.ui.theme.SuppliesTheme
import org.jetbrains.compose.web.css.AnimationTimingFunction
import org.jetbrains.compose.web.css.deg
import org.jetbrains.compose.web.css.s

val spinnerAnimationKeyframes = Keyframes{
    from { Modifier.rotateZ(0f.deg) }
    to { Modifier.rotateZ(360.deg) }
}

@Composable
fun NLLoading(size: IconSize = IconSize.XL, modifier: Modifier = Modifier){
    FaSpinner(
        size = size,
        modifier = modifier
            .color(SuppliesTheme.colors.primary)
            .animation(
                spinnerAnimationKeyframes.toAnimation(
                    duration = 1.s,
                    iterationCount = AnimationIterationCount.Infinite,
                    timingFunction = AnimationTimingFunction.steps(8)
                )
            )
    )
}